import { brandPrimaryHover } from '../../../../styles/colors';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	title: {
		color: brandPrimaryHover,
		margin: '0 0 15px',
	},
});
